/**
 * Every string the case queue renders, transcribed from the UI/UX pack.
 *
 * **The division note is gone, because the division is gone.** It pointed at the
 * report queue — «للبتّ في بلاغ… افتحه من طابور البلاغات» — and that queue was
 * this one filtered to `caseType=CONTENT_REPORT`. The decision it sent the
 * operator away for is now on the case detail, so a line telling them the actions
 * live somewhere else would be telling them to leave the page that has them.
 */
export const copy = {
  crumb: 'الحالات',

  head: {
    title: 'الحالات',
    lede: 'كلّ ما يراسلك به المشتركون في مكان واحد: تذاكر الدعم، والبلاغات عن المحتوى والحسابات، وطلبات العناوين، وبلاغات الأعطال. افتح أيّ حالة لتقرأ خيطها وتردّ فيه وتضبط وضعها.',
  },

  section: {
    heading: 'طابور الحالات',
    context: 'مرتّبة بآخر تحديث، الأحدث أوّلاً. الحالات المُعالَجة والمغلقة تبقى في القائمة ولا تُحذف منها.',
  },

  caption: 'طابور الحالات عبر الأنواع الخمسة والأوضاع الأربعة',

  columns: {
    case: 'الحالة',
    owner: 'صاحب الحالة',
    state: 'الوضع',
    updated: 'آخر تحديث',
  },

  /**
   * The traversal control. The service pages this queue by keyset and returns
   * no total — a count query per page is the cost the keyset mode exists to
   * avoid — so the line states the page walked to and the rows on it, and never
   * a «page N of M» the console would have to invent.
   */
  pager: {
    label: 'صفحات الحالات',
    shownOne: 'حالة واحدة معروضة',
    shownTwo: 'حالتان معروضتان',
    shownFew: 'حالات معروضة',
    shownMany: 'حالة معروضة',
  },

  /**
   * The queue's own lookup. Not a search: the service matches the reference
   * exactly, which is what makes it the token two people can quote at each other.
   */
  lookup: {
    label: 'افتح حالة برقمها المرجعي',
    placeholder: 'الصق الرقم المرجعي…',
    hint: 'المطابقة تامّة بالرقم المرجعي، لا بحث في نصّ الحالات.',
  },

  states: {
    loading: 'جارٍ تحميل الحالات',
    /** Empty is not the good state here — a queue with nothing in it is quiet, not done. */
    empty: 'لا حالة في الطابور. كلّ ما وصل عولج.',
    /**
     * A page walked past the end of the queue — not an empty queue. The two
     * cannot share a sentence: «كلّ ما وصل عولج» on page four would tell an
     * operator the work is done when what happened is that they walked one page
     * too far.
     */
    emptyPage: 'لا حالة في هذه الصفحة. عد إلى السابقة.',
    /**
     * The reference matched nothing — a third empty state, and it may not
     * borrow either sentence above: the queue is neither drained nor walked
     * past its end, the number simply names no case here.
     */
    emptyLookup: (reference: string) => `لا حالة بالرقم المرجعي «${reference}».`,
    emptyLookupAction: 'عد إلى الطابور',
  },
} as const;
